import { bool, object, shape } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled, { withTheme } from 'styled-components';

import { callFunc } from 'ravenjs/utils/actions';
import Iframe from 'ravenjs/lib/Iframe';
import { get } from 'ravenjs/utils/lodash';
import { renderCheck } from 'ravenjs/utils/viewport';
import Button from 'ravenjs/lib/Button';
import { getThemeProps } from 'ravenjs/utils/theme';

import { DEFAULT_COLORS } from 'constants/colors';
import { MODALS } from 'constants/modals';
import { selectors as uiSelectors } from 'modules/ui';
import { CloseIcon } from 'components/Icons';

import { MODAL_LEARN_BUTTON_LABEL } from 'constants/content';

import Modal from '../Modal';

const ActionButton = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
`;

const ContentWrapper = styled.div`
    height: calc(100vh - 72px);
    ${({ theme }) => theme.media.up('md')`
        max-width: 100%;
    `};
`;

const TrainingCourseModal = props => {
    const { modal, theme } = props;
    const open = get(modal, 'open', false);
    const trainingCourseUrl = get(modal, 'data.trainingCourseUrl', '');

    const onClickCloseIcon = () => {
        const onClose = get(modal, 'data.onClose');

        callFunc(onClose);
    };

    const renderContent = () => {
        return (
            <>
                <ActionButton>
                    <Button
                        color="primary"
                        padding="0.65rem 1.5rem"
                        borderRadius="50px"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily: 'Favorit',
                            fontSize: '0.875rem',
                        }}
                        noMinWidth
                        data-testid="modal-close-icon"
                        onClick={onClickCloseIcon}
                    >
                        {MODAL_LEARN_BUTTON_LABEL}
                        <CloseIcon
                            fill={getThemeProps('palette.primary.text', DEFAULT_COLORS.WHITE, {
                                theme,
                            })}
                            margin="0 0 0 0.5rem"
                            width="18"
                            height="18"
                        />
                    </Button>
                </ActionButton>
                <ContentWrapper>
                    <Iframe id="gnTrainingCourseIframe" src={trainingCourseUrl} />
                </ContentWrapper>
            </>
        );
    };

    return (
        <Modal
            hideActions
            id={MODALS.TRAINING_COURSE}
            actions={[]}
            content={renderContent()}
            open={open}
            title=""
            ModalProps={{
                ContentProps: {
                    style: {
                        maxWidth: '100%',
                        height: '100%',
                        maxHeight: '100%',
                    },
                },
            }}
            modalBodyProps={{
                backgroundColor: DEFAULT_COLORS.WHITE,
                overflow: renderCheck('md', 'less') ? undefined : 'hidden',
                paddingTop: '0',
            }}
            modalHeaderProps={{
                border: 'none',
                fontSize: '1.75rem',
                paddingBottom: '1.5rem',
                paddingTop: '1rem',
            }}
        />
    );
};

TrainingCourseModal.propTypes = {
    modal: shape({
        open: bool,
    }).isRequired,
    theme: object.isRequired,
};

const mapStateToProps = () =>
    createStructuredSelector({
        modal: uiSelectors.getModalById(MODALS.TRAINING_COURSE),
    });

export { TrainingCourseModal as TrainingCourseModalUnwrapped };
export default withTheme(connect(mapStateToProps, null)(TrainingCourseModal));
